import SummaryCard from "../components/SummaryCard";
import { formatCurrency } from "../utils/formatters";

export default function DashboardSummary({ summary }) {
  const summaryCards = [
    ["New orders", summary.new_orders],
    ["Orders today", summary.orders_today],
    ["Today revenue", formatCurrency(summary.today_revenue)],
    ["Week revenue", formatCurrency(summary.week_revenue)],
    ["Pending catering", summary.pending_catering_requests],
    ["Avg order", formatCurrency(summary.average_order_value)],
  ];

  return (
    <section className="admin-summary">
      {summaryCards.map(([label, value]) => (
        <SummaryCard key={label} label={label} value={value} />
      ))}
    </section>
  );
}